import * as React from "react";
const ScrollToTopIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={66} height={66}>
        <defs>
            <filter id="a" width="123.2%" height="123.2%" x="-11.6%" y="-11.6%" filterUnits="objectBoundingBox">
                <feMorphology in="SourceAlpha" operator="dilate" radius={0.5} result="shadowSpreadOuter1" />
                <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation={2} />
                <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                <feColorMatrix
                    in="shadowBlurOuter1"
                    values="0 0 0 0 0.176470588 0 0 0 0 0.160784314 0 0 0 0 0.149019608 0 0 0 0.308921547 0"
                />
            </filter>
            <circle id="b" cx={28} cy={28} r={28} />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(5 5)">
            <use xlinkHref="#b" fill="#000" filter="url(#a)" />
            <use xlinkHref="#b" fill="#FFF" stroke="#BBB" />
            <path
                fill="#006AE3"
                fillRule="nonzero"
                d="M29.198 36c.742 0 1.397-.49 1.397-1.272v-7.652l3.208 3.185c.25.26.611.413.982.413s.731-.152.993-.413l.818-.815c.251-.261.404-.609.404-.979s-.153-.728-.404-.989l-7.103-7.076c-.262-.26-.622-.402-.993-.402s-.731.141-.982.402l-7.103 7.076c-.262.261-.415.62-.415.99 0 .369.153.717.415.978l.818.815a1.375 1.375 0 0 0 1.964 0l3.208-3.185v7.652c0 .783.655 1.272 1.397 1.272h1.396z"
            />
        </g>
    </svg>
);
export default ScrollToTopIcon;
